<template>
  <div class="mobile-header-bar">
    <div class="logo" @click="() => $router.push({ name: 'mhome' })">
      <img src="/imgs/logo.png" alt=""/>
    </div>
    <div class="function-area">
      <div class="dropdown">
        <button class="dropdown-button" @click="toggleDropdown">
          {{ getNameByValue(language) }}
          <span class="caret"><icon class="el-icon-arrow-down"></icon></span>
        </button>
        <div class="dropdown-content" v-if="showDropdown">
          <div
              v-for="(lang, index) in languages"
              :key="index"
              @click="changeLangEvent(lang.value)"
              class="dropdown-item"
          >
            {{ lang.name }}
          </div>
        </div>
      </div>
      <div class="menu-btn" @click="drawer = true"></div>
    </div>
    <el-drawer :visible.sync="drawer" @close="drawerClose">
      <div slot="title" class="custom-drawer-title">
        <img src="/imgs/logo.png" alt=""/>
      </div>
      <div>
        <div>
          <ul class="menu-box">
            <li class="menu-item" @click.stop="goThere('crypto')">{{ $t("specialMenu.crypto") }}</li>
            <li class="menu-item" @click.stop="goThere('virtualCard')">{{ $t("specialMenu.virtualCard") }}</li>
            <li :key="el.name" v-for="el in $t('footerMenu')" class="menu-group">
              <div class="menu-item" @click="toggleSubMenu(el)">
                <span class="menu-item-title">{{ el.name }}</span>
                <i class="el-icon-arrow-right"></i>
              </div>
              <ul v-if="el.childList && el.childList.length"
                  v-show="activeSubMenu === el"
                  class="submenu">
                <li
                    v-for="child in el.childList"
                    :key="child.name"
                    @click.stop="goThere(child.url)"
                    class="submenu-item"
                >{{ child.name }}</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "MobileHeaderBar",
  data() {
    return {
      drawer: false,
      activeSubMenu: null,
      showDropdown: false,
      language: localStorage.getItem("locale") || "zh",
      languages: [
        {
          name: 'English',
          value: 'en'
        },
        {
          name: '简体中文',
          value: 'zh'
        },
        {
          name: '日本語',
          value: 'jpn'
        }
      ]
    };
  },
  methods: {
    toggleSubMenu(el) {
      this.activeSubMenu = this.activeSubMenu === el ? null : el;
    },
    goThere(url) {
      this.drawer = false;
      this.activeSubMenu = null;
      this.$router.push({
        name: "m" + url,
      });
    },
    drawerClose() {
      this.drawer = false;
      this.activeSubMenu = null;
    },
    getNameByValue(value) {
      const lang = this.languages.find(lang => lang.value === value);
      return lang ? lang.name : '';
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    changeLangEvent(value){
      localStorage.setItem("locale", value);
      this.$i18n.locale = localStorage.getItem("locale");
      this.language = value;
      location.reload();
      this.showDropdown = false;
    }
  },
};
</script>

<style lang="less" scoped>
::v-deep .el-drawer.rtl {
  width: 100% !important;
  margin-bottom: 10px;
}

::v-deep .el-drawer__header {
  margin-bottom: 15px;
}

::v-deep .el-drawer__close-btn {
  font-size: 24px;
}

.mobile-header-bar {
  width: 95%;
  margin: 0 3%;
  height: 2.222rem;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .logo {
    line-height: 2.222rem;
    height: 2.222rem;

    img {
      width: auto;
      height: 50%;
      vertical-align: middle;
    }
  }

  .function-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .menu-btn {
    width: 1rem;
    height: 1rem;
    background: url(../../../../public/imgs/menu-icon.png) center no-repeat;
    background-size: 100% 100%;
  }
}

.menu-box {
  padding: 0 1rem;

  .menu-group {
    display: block;
    margin-bottom: 0.4rem;
  }

  .menu-item {
    display: flex;
    justify-content: space-between; // 自动拉开间距
    align-items: center; // 垂直居中
    font-size: 0.667rem;
    padding: 0.4rem 0;
    color: #0c0c0c;
    cursor: pointer;
  }

  .submenu {
    list-style-type: none;
    margin: 0;
    padding-left: 1rem;
    margin-top: 0.4rem;
    z-index: 10;
    position: relative;

    .submenu-item {
      font-size: 0.667rem;
      padding: 0.4rem 0;
      color: #0c0c0c;
      cursor: pointer;
    }
  }
}

.dropdown {
  position: relative;
  display: inline-block;

  .dropdown-button {
    border: none;
    background-color: transparent;
    padding: 0.5rem 1rem;
    font-size: 0.65rem;
    cursor: pointer;
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: none; /* 去除聚焦时可能出现的阴影 */
  }

  /* 去掉点击后的轮廓线 */
  .dropdown-button:focus {
    outline: none;
  }

  .caret {
    margin-left: 0.5rem;
  }

  .dropdown-content {
    position: absolute;
    left: 0;
    top: 100%; /* 紧贴按钮下方 */
    display: block;
    background-color: #fff;
    min-width: 7rem;
    box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.2);
    border: 1px solid #ddd;
    border-top: none;
    max-height: 200px;
    overflow-y: auto;
    z-index: 9999;
    border-radius: 8px;
  }

  .dropdown-item {
    padding: 10px 20px;
    cursor: pointer;
  }

  .dropdown-item:hover {
    background-color: #f1f1f1;
  }
}
</style>
